import { Flex } from '@chakra-ui/react';
import { serializeQuestions, sortQuestionsByOrder } from '~/components/Forms/utils';
import Hero from '~/components/Hero';
import Layout from '~/components/Layout';
import SectionWithTitle from '~/components/SectionWithTitle';
import SEO from '~/components/SEO';
import StyledLink from '~/components/StyledLink';
import Text from '~/components/Text';
import ContactForm from '~/templates/components/Contact/ContactForm';
import { getCurrentOrigin } from '~/utils/getCurrentDomain';
import { getSeoDataFromWordpressForPage } from '~/utils/getSeoData';
import { createImageWithArtDirection } from '~/utils/imageUtils';
import React from 'react';

var PageContactTemplate = function PageContactTemplate(props) {
  var _data$wpPage, _pageDataAcf$hero, _pageDataAcf$hero$des, _pageDataAcf$hero$des2, _pageDataAcf$hero$des3, _pageDataAcf$hero$des4, _pageDataAcf$hero2, _pageDataAcf$hero3, _pageData$acfContact, _pageData$acfContact$, _pageDataAcf$hero4, _pageDataAcf$contactS, _pageData$acfContact2, _pageData$acfContact3, _pageData$acfContact4, _pageData$acfContact5, _pageData$acfContact6, _pageData$acfContact7, _pageDataAcf$contactS2, _pageDataAcf$contactS3, _pageDataAcf$contactS4;

  var data = props.data;
  var pageContext = props.pageContext;
  var pageData = data.wpPage;
  var pageDataAcf = (_data$wpPage = data.wpPage) === null || _data$wpPage === void 0 ? void 0 : _data$wpPage.acfContact;
  if (!pageData || !pageDataAcf || !(pageData !== null && pageData !== void 0 && pageData.link) || !pageContext.defaultLanguage) return null;
  var seoProps = getSeoDataFromWordpressForPage({
    availableTranslations: pageData.translations,
    currentLanguage: pageData.language.locale,
    currentOrigin: getCurrentOrigin(),
    defaultLanguage: pageContext.defaultLanguage,
    featuredImageUrl: (_pageDataAcf$hero = pageDataAcf.hero) === null || _pageDataAcf$hero === void 0 ? void 0 : (_pageDataAcf$hero$des = _pageDataAcf$hero.desktopFeaturedImage) === null || _pageDataAcf$hero$des === void 0 ? void 0 : (_pageDataAcf$hero$des2 = _pageDataAcf$hero$des.localFile) === null || _pageDataAcf$hero$des2 === void 0 ? void 0 : (_pageDataAcf$hero$des3 = _pageDataAcf$hero$des2.childImageSharp) === null || _pageDataAcf$hero$des3 === void 0 ? void 0 : (_pageDataAcf$hero$des4 = _pageDataAcf$hero$des3.gatsbyImageData) === null || _pageDataAcf$hero$des4 === void 0 ? void 0 : _pageDataAcf$hero$des4.src,
    pagePath: props.location.pathname,
    pageSlug: pageData.slug,
    seo: pageData.seo
  });
  var imageWithArtDirection = createImageWithArtDirection({
    desktopImage: (_pageDataAcf$hero2 = pageDataAcf.hero) === null || _pageDataAcf$hero2 === void 0 ? void 0 : _pageDataAcf$hero2.desktopFeaturedImage,
    mobileImage: (_pageDataAcf$hero3 = pageDataAcf.hero) === null || _pageDataAcf$hero3 === void 0 ? void 0 : _pageDataAcf$hero3.mobileFeaturedImage
  });
  if (!((_pageData$acfContact = pageData.acfContact) !== null && _pageData$acfContact !== void 0 && (_pageData$acfContact$ = _pageData$acfContact.contactSection) !== null && _pageData$acfContact$ !== void 0 && _pageData$acfContact$.questionsList)) return null; // @ts-ignore

  var sortedQuestions = sortQuestionsByOrder(pageData.acfContact.contactSection.questionsList);
  var serializedContactFormQuestions = serializeQuestions(sortedQuestions);
  return /*#__PURE__*/React.createElement(Layout, {
    currentLanguage: pageData.language,
    currentPath: pageData.link,
    menuData: pageContext.menus,
    siteSettings: pageContext.siteSettings,
    translations: pageData.translations
  }, /*#__PURE__*/React.createElement(SEO, seoProps), /*#__PURE__*/React.createElement(Hero, {
    backgroundImage: imageWithArtDirection,
    couleurTitre: "#000",
    heading: (_pageDataAcf$hero4 = pageDataAcf.hero) === null || _pageDataAcf$hero4 === void 0 ? void 0 : _pageDataAcf$hero4.title,
    size: "short"
  }), /*#__PURE__*/React.createElement(SectionWithTitle, {
    heading: (_pageDataAcf$contactS = pageDataAcf.contactSection) === null || _pageDataAcf$contactS === void 0 ? void 0 : _pageDataAcf$contactS.title,
    maxW: 1200
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: {
      base: 'column',
      lg: 'row'
    },
    w: "100%"
  }, /*#__PURE__*/React.createElement(ContactForm, {
    feedbackMessages: {
      error: (_pageData$acfContact2 = pageData.acfContact) === null || _pageData$acfContact2 === void 0 ? void 0 : (_pageData$acfContact3 = _pageData$acfContact2.contactSection) === null || _pageData$acfContact3 === void 0 ? void 0 : _pageData$acfContact3.errorMsg,
      success: (_pageData$acfContact4 = pageData.acfContact) === null || _pageData$acfContact4 === void 0 ? void 0 : (_pageData$acfContact5 = _pageData$acfContact4.contactSection) === null || _pageData$acfContact5 === void 0 ? void 0 : _pageData$acfContact5.successMsg
    },
    pageUrl: props.location.pathname,
    questions: serializedContactFormQuestions,
    defaultValues: props.location.state,
    submitButton: (_pageData$acfContact6 = pageData.acfContact) === null || _pageData$acfContact6 === void 0 ? void 0 : (_pageData$acfContact7 = _pageData$acfContact6.contactSection) === null || _pageData$acfContact7 === void 0 ? void 0 : _pageData$acfContact7.cta
  }), /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    px: {
      base: 0,
      lg: 16
    }
  }, /*#__PURE__*/React.createElement(Text, {
    mb: 4
  }, (_pageDataAcf$contactS2 = pageDataAcf.contactSection) === null || _pageDataAcf$contactS2 === void 0 ? void 0 : _pageDataAcf$contactS2.text), /*#__PURE__*/React.createElement(StyledLink, {
    shouldObfuscate: true,
    isEmail: true,
    to: (_pageDataAcf$contactS3 = pageDataAcf.contactSection) === null || _pageDataAcf$contactS3 === void 0 ? void 0 : _pageDataAcf$contactS3.contactMail
  }, /*#__PURE__*/React.createElement(Text, null, (_pageDataAcf$contactS4 = pageDataAcf.contactSection) === null || _pageDataAcf$contactS4 === void 0 ? void 0 : _pageDataAcf$contactS4.contactMail))))));
};

export default PageContactTemplate;
var query = "313713641";